// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating User records.
 * @typedef {object} UserWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [email] - Value for the email attribute.
 * @property {string | null} [firstName] - Value for the firstName attribute.
 * @property {string | null} [lastName] - Value for the lastName attribute.
 * @property {string | null} [locale] - Value for the locale attribute.
 * @property {boolean | null} [active] - Value for the active attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 */

/** @augments {DatabaseRecord<UserWriteAttributes>} */
export default class UserBase extends DatabaseRecord {
  /** @returns {typeof import("../models/user.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/user.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  email() { return this.readAttribute("email") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setEmail(newValue) { return this._setColumnAttribute("email", newValue) }

  /** @returns {boolean} */
  hasEmail() { return this._hasAttribute(this.email()) }

  /** @returns {string | null} */
  firstName() { return this.readAttribute("firstName") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setFirstName(newValue) { return this._setColumnAttribute("firstName", newValue) }

  /** @returns {boolean} */
  hasFirstName() { return this._hasAttribute(this.firstName()) }

  /** @returns {string | null} */
  lastName() { return this.readAttribute("lastName") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setLastName(newValue) { return this._setColumnAttribute("lastName", newValue) }

  /** @returns {boolean} */
  hasLastName() { return this._hasAttribute(this.lastName()) }

  /** @returns {string | null} */
  locale() { return this.readAttribute("locale") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setLocale(newValue) { return this._setColumnAttribute("locale", newValue) }

  /** @returns {boolean} */
  hasLocale() { return this._hasAttribute(this.locale()) }

  /** @returns {boolean | null} */
  active() { return this.readAttribute("active") }

  /**
   * @param {boolean | null} newValue
   * @returns {void}
   */
  setActive(newValue) { return this._setColumnAttribute("active", newValue) }

  /** @returns {boolean} */
  hasActive() { return this._hasAttribute(this.active()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }
}
